// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Group, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor, Badge } from '@/components/ui/core';
import { TextInput } from '@/components/ui/inputs';
import { IconMail, IconArrowLeft, IconArrowRight, IconLockQuestion } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';

export default function ForgotModern() {
  const [email, setEmail] = useState('');
  const [step, setStep] = useState(1);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStep(2);
  };

  return (
    <AuthLayoutWrapper variant="modern">
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/forgot-password"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Progress indicator */}
        <Group justify="center" gap="xs">
          <Badge color={step >= 1 ? 'orange' : 'gray'} variant={step >= 1 ? 'filled' : 'outline'} circle>
            1
          </Badge>
          <div style={{ width: 40, height: 2, backgroundColor: step >= 2 ? 'var(--mantine-color-orange-6)' : 'var(--mantine-color-gray-3)' }} />
          <Badge color={step >= 2 ? 'orange' : 'gray'} variant={step >= 2 ? 'filled' : 'outline'} circle>
            2
          </Badge>
          <div style={{ width: 40, height: 2, backgroundColor: step >= 3 ? 'var(--mantine-color-orange-6)' : 'var(--mantine-color-gray-3)' }} />
          <Badge color={step >= 3 ? 'orange' : 'gray'} variant={step >= 3 ? 'filled' : 'outline'} circle>
            3
          </Badge>
        </Group>

        {step === 1 && (
          <>
            {/* Header */}
            <Center>
              <Stack align="center" gap="xs">
                <Center
                  style={{
                    width: 64,
                    height: 64,
                    borderRadius: 16,
                    backgroundColor: 'var(--mantine-color-orange-light)',
                  }}
                >
                  <IconLockQuestion size={32} color="var(--mantine-color-orange-6)" />
                </Center>
                <Title order={2} ta="center" mt="sm">Reset your password</Title>
                <Text c="dimmed" size="sm" ta="center" maw={300}>
                  Step 1: Enter your email address to receive a reset link
                </Text>
              </Stack>
            </Center>

            {/* Form */}
            <form onSubmit={handleSubmit}>
              <Stack gap="md">
                <TextInput
                  label="Email address"
                  placeholder="name@company.com"
                  leftSection={<IconMail size={16} />}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  size="md"
                  radius="md"
                />

                <Button
                  type="submit"
                  fullWidth
                  size="md"
                  color="orange"
                  rightSection={<IconArrowRight size={16} />}
                >
                  Continue
                </Button>
              </Stack>
            </form>
          </>
        )}

        {step === 2 && (
          <Center>
            <Stack align="center" gap="lg">
              <Center
                style={{
                  width: 80,
                  height: 80,
                  borderRadius: 20,
                  backgroundColor: 'var(--mantine-color-green-light)',
                }}
              >
                <IconMail size={40} color="var(--mantine-color-green-6)" />
              </Center>

              <Stack align="center" gap="xs">
                <Title order={2} ta="center">Check your inbox</Title>
                <Text c="dimmed" size="sm" ta="center" maw={320}>
                  We've sent a password reset link to <strong>{email}</strong>.
                  Click the link in the email to reset your password.
                </Text>
              </Stack>

              <Stack gap="sm" w="100%">
                <Button
                  variant="light"
                  color="orange"
                  fullWidth
                  onClick={() => setStep(1)}
                >
                  Didn't receive it? Resend
                </Button>
                <Button
                  component={Link}
                  to="/app/demo/auth-pages/login/modern"
                  variant="subtle"
                  fullWidth
                >
                  Back to login
                </Button>
              </Stack>
            </Stack>
          </Center>
        )}

        {step === 1 && (
          <Text ta="center" size="sm">
            Remember your password?{' '}
            <Anchor component={Link} to="/app/demo/auth-pages/login/modern" fw={500} c="orange">
              Sign in
            </Anchor>
          </Text>
        )}
      </Stack>
    </AuthLayoutWrapper>
  );
}
